import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "apartment__thumb mr-3" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "fs-18 text-gray" }
const _hoisted_5 = { class: "d-flex align-items-center mt-3" }
const _hoisted_6 = { class: "apartment-dashboard" }
const _hoisted_7 = { class: "apartment-dashboard__main" }
const _hoisted_8 = { class: "list-blocks" }
const _hoisted_9 = { class: "apartment-dashboard__meta" }
const _hoisted_10 = { class: "apartment-meta__content" }
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = { class: "apartment-meta__head" }
const _hoisted_13 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_14 = { class: "mt-1 mb-0" }
const _hoisted_15 = { class: "apartment-meta__content" }
const _hoisted_16 = { class: "apartment-meta__head" }
const _hoisted_17 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_18 = { class: "apartment-meta__content" }
const _hoisted_19 = { class: "apartment-meta__head" }
const _hoisted_20 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_21 = { class: "apartment-meta__content" }
const _hoisted_22 = { class: "apartment-meta__head" }
const _hoisted_23 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Room = _resolveComponent("Room")
  const _component_CardContainer = _resolveComponent("CardContainer")
  const _component_PlantDashboardDevices = _resolveComponent("PlantDashboardDevices")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode("img", {
            src: _ctx.imageURLs[0],
            srcset: _ctx.imageSrcSetURLs,
            alt: "img"
          }, null, 8, ["src", "srcset"])
        ]),
        _createVNode("div", null, [
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.currentPlant?.name), 1),
          _createVNode("address", _hoisted_4, _toDisplayString(_ctx.currentPlant.address) + ", " + _toDisplayString(_ctx.currentPlant.country), 1)
        ]),
        _renderSlot(_ctx.$slots, "head-menu")
      ]),
      _createVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "update-time-meta")
      ])
    ]),
    _createVNode("section", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_CardContainer, {
          titleIcon: require('@/assets/images/icons/icon-blueprint.svg'),
          title: `${_ctx.currentPlant.rooms.length} ${_ctx.$t(
                    'AppResource.RoomsUpper'
                )}`,
          showActionButton: _ctx.plantAddRoomEnabled,
          onOnActionButtonClick: _ctx.toggleCreateStructureDialog,
          actionButtonLabel: _ctx.$t('AppResource.AddARoom')
        }, {
          default: _withCtx(() => [
            _createVNode("ul", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentPlant?.rooms, (room, index) => {
                return (_openBlock(), _createBlock(_component_Room, {
                  key: `${room.id}-${index}`,
                  room: room,
                  plantId: _ctx.currentPlant?.desktopId,
                  onAddObject: () => _ctx.toggleAddRoomObjectDialog(room)
                }, null, 8, ["room", "plantId", "onAddObject"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["titleIcon", "title", "showActionButton", "onOnActionButtonClick", "actionButtonLabel"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_PlantDashboardDevices, {
          "last-scan-time": _ctx.lastScanTime,
          "last-scan-date": _ctx.lastScanDate,
          devices: _ctx.plantDevices
        }, null, 8, ["last-scan-time", "last-scan-date", "devices"]),
        _createVNode(_component_Card, {
          class: "apartment-meta card--slim",
          onClick: _ctx.goToEosSettings
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: _ctx.serverIcon,
                      "aria-label": "icon-network"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h5", null, _toDisplayString(_ctx.mxServerLabel), 1)
                ]),
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.currentPlant.gwId), 1)
              ]),
              _createVNode(_component_Button, {
                icon: "pi pi-chevron-right",
                class: "p-button-text p-button-secondary ml-2",
                onClick: _ctx.goToEosSettings
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Card, {
          class: "apartment-meta card--slim",
          onClick: _ctx.goToGeneralCommands
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                        require(`@/assets/images/icons/icon-command.svg`)
                                    ,
                    "aria-label": "icon-command"
                  }, null, 8, ["src"])
                ]),
                _createVNode("h5", null, _toDisplayString(_ctx.currentPlant.aggregateCommandsCount) + " " + _toDisplayString(_ctx.$t("AppResource.GeneralCommandsAndGroups")), 1)
              ]),
              _createVNode(_component_Button, {
                icon: "pi pi-chevron-right",
                class: "p-button-text p-button-secondary ml-auto",
                onClick: _ctx.goToGeneralCommands
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Card, {
          class: "apartment-meta card--slim",
          onClick: _ctx.goToScenes
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                        require(`@/assets/images/icons/icon-automation.svg`)
                                    ,
                    "aria-label": "icon-automation"
                  }, null, 8, ["src"])
                ]),
                _createVNode("h5", null, _toDisplayString(_ctx.currentPlant.scenesCount) + " " + _toDisplayString(_ctx.$t("AppResource.Scenes")), 1)
              ]),
              _createVNode(_component_Button, {
                icon: "pi pi-chevron-right",
                class: "p-button-text p-button-secondary ml-2 ml-auto"
              })
            ])
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.showAlarmSystem)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "apartment-meta card--slim",
              onClick: _ctx.goToAlarmSystem
            }, {
              content: _withCtx(() => [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("span", _hoisted_23, [
                      _createVNode(_component_InlineSvgScoped, {
                        class: "text-success",
                        src: 
                                        require(`@/assets/images/icons/icon-confirm-outline.svg`)
                                    ,
                        "aria-label": "icon-alarm"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResource.Alarmsystem")), 1)
                  ]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-right",
                    class: "p-button-text p-button-secondary ml-2 ml-auto"
                  })
                ])
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}